module.exports = __webpack_public_path__ + "img/profile.0d09cb21.png";